import { render, staticRenderFns } from "./JournalSystemForm.vue?vue&type=template&id=245d30a8&"
import script from "./JournalSystemForm.vue?vue&type=script&lang=js&"
export * from "./JournalSystemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports